import {
  ProjectDashboardStepConfig,
  ProjectDashboardStepItem,
  ProjectDashboardStepStatus
} from './project-dashboard-stepper.component';

export function withStatus(
  steps: ReadonlyArray<ProjectDashboardStepConfig>,
  currentStage: string | null
): ProjectDashboardStepItem[] {
  const activeIndex = steps.findIndex((step) => step.key === currentStage);
  const resolvedActiveIndex = activeIndex === -1 ? 0 : activeIndex;

  return steps.map((step, index) => {
    let status: ProjectDashboardStepStatus = 'upcoming';
    if (index < resolvedActiveIndex) status = 'completed';
    if (index === resolvedActiveIndex) status = 'active';
    return { ...step, status };
  });
}
